export function routes($stateProvider) {
    $stateProvider
        .state('app.crm.propostas', {
        url: '/propostas',
        abstract: true
    })
        .state('app.crm.propostas.list', {
        url: '?{page:int}&{items:int}&{state:int}&order&sort&filter',
        title: 'Propostas',
        template: '<crm-propostas-list-view></crm-propostas-list-view>',
        params: {
            page: {
                value: 1,
                dynamic: true
            },
            limit: {
                value: 20,
                dynamic: true
            },
            sortBy: {
                array: true,
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        }
    })
        .state('app.crm.propostas.details', {
        url: '/{id:int}',
        title: 'Detalhes da Proposta',
        template: '<crm-propostas-details-view></crm-propostas-details-view>',
        //role: ['crmListarContactos'],
        params: {
            page: {
                value: 1,
                dynamic: true
            },
            limit: {
                value: 20,
                dynamic: true
            },
            sortBy: {
                array: true,
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        }
    });
}
routes.$inject = ['$stateProvider'];
